import React from "react";

function ArrowSvg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            className="fill-current"
        >
            <path d="M18.0438 23.5254C17.8063 23.5254 17.5688 23.4379 17.3812 23.2504C17.0188 22.8879 17.0188 22.2879 17.3812 21.9254L24.3063 15.0004L17.3812 8.07539C17.0188 7.71289 17.0188 7.11289 17.3812 6.75039C17.7437 6.38789 18.3438 6.38789 18.7063 6.75039L26.2938 14.3379C26.6563 14.7004 26.6563 15.3004 26.2938 15.6629L18.7063 23.2504C18.5188 23.4379 18.2813 23.5254 18.0438 23.5254Z" />
            <path d="M25.4125 15.9375H4.375C3.8625 15.9375 3.4375 15.5125 3.4375 15C3.4375 14.4875 3.8625 14.0625 4.375 14.0625H25.4125C25.925 14.0625 26.35 14.4875 26.35 15C26.35 15.5125 25.925 15.9375 25.4125 15.9375Z" />
        </svg>
    );
}

export default ArrowSvg;
